import React, { Fragment } from 'react';
import Bugsnag from '@bugsnag/js';
import BugsnagPluginReact from '@bugsnag/plugin-react';

import config from '../../config';
import { version } from '../../../package.json';

let bugsnagClient = null;
const bugsnagComponent = Fragment;

if(typeof window !== 'undefined' && config.bugsnag && config.bugsnag.key) {
    bugsnagClient = Bugsnag;

    Bugsnag.start({
        apiKey: config.bugsnag.key,
        appVersion: version,
        notifyReleaseStages: ['production'],
        appType: 'client',
        plugins: [new BugsnagPluginReact(React)],
    });
}


export function notifyError(error, meta = {}) {
    bugsnagClient && bugsnagClient.notify(error, meta);
}

export default bugsnagComponent;
